import React from 'react'
import San from '../Images/SAN Techn-logo.png'
// import { FaCheckCircle } from 'react-icons/fa';

export default function Header() {
    return (
        <div className=" mx-auto  px-4 bg-slate-100" >
            <div className="flex items-center justify-around pb-6 pt-6">
                {/* Logo on the left */}
                <img src={San} alt="San Technonation" className="w-45 h-20 object-contain " />

                {/* Title on the right */}
                <h2 className="text-lg md:text-3xl font-bold text-primary-900 text-right">
                    Student Admission
                </h2>
            </div>
        </div>


    )
}
